export const tr = {
    'button-text': 'Video eklentili tüm reklamlar'
};
